import _ from 'lodash'
import { combineReducers } from 'redux'
import { reducers } from '@adc/ui-morpheus'
import {
  CLEAR_EVENT_TEMPLATES,
  UPDATE_EVENT_TEMPLATE_IN_LIST,
} from '../../constants/actionTypes'
import { EVENT_TEMPLATES } from '../../constants/tableTypes'
import tableReducer from './columnDefinitions'

const initialState = {
  content: [],
  total_elements: 0,
}

const eventTemplatesReducer = (state = initialState, action) => {
  switch (action.type) {
    case CLEAR_EVENT_TEMPLATES:
      return initialState
    case UPDATE_EVENT_TEMPLATE_IN_LIST: {
      const templates = state
      const updatedTemplate = action.eventTemplate

      if (
        templates.total_elements > 0 &&
        templates.content &&
        templates.content.length > 0
      ) {
        const matchIndex = _.findIndex(templates.content, {
          event_template_id: updatedTemplate.event_template_id,
        })
        if (matchIndex > -1) {
          // replace with new updatedTemplate
          return Object.assign({}, state, {
            content: Object.assign([...templates.content], {
              [matchIndex]: updatedTemplate,
            }),
          })
        }
        return state
      } else {
        return state
      }
    }

    default:
      return reducers.dataTable.tableFetchReducer(
        EVENT_TEMPLATES,
        state,
        action
      )
  }
}

export default combineReducers({
  data: eventTemplatesReducer,
  tableInfo: tableReducer,
  savedSearches: (state, action) =>
    reducers.dataTable.savedSearchesReducer(EVENT_TEMPLATES, state, action),
})
export { initialState, eventTemplatesReducer }
